import React, { useEffect } from 'react';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../styles/MainContent.css';
import MaintenancePopup from './MaintenancePopup';

function MainContent() {
  useEffect(() => {
    const swiper = new Swiper('.swiper', {
      modules: [Navigation, Pagination, Autoplay],
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      direction: 'horizontal',
    });
    
    return () => {
      swiper.destroy();
    };
  }, []);

  return (
    <div className="main-content">
      <MaintenancePopup />
      <img className="background-image" src="index/img1.jpg" alt="Background" />
      <img className="background-image" src="index/img2.jpg" alt="Background" />
      
      <div className="swiper">
        <div className="swiper-wrapper">
          {[...Array(13)].map((_, index) => (
            <div className="swiper-slide" key={index + 1}>
              <img src={`index/flash/${index + 1}.png`} alt={`Slide ${index + 1}`} />
            </div>
          ))}
        </div>
        <div className="swiper-pagination"></div>
      </div>
      
      <div className="video-container">
        <video controls autoPlay muted loop>
          <source src="../index/video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
}

export default MainContent;